var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useParams } from 'react-router-dom';
import { Box, LoadingBox, translate } from '@lucidlink/uicore';
import { useGetDeveloperPlatformCapabilities } from '#query-hooks';
export const WorkspaceNativeLayoutRouteGuard = ({ children, }) => {
    _react_refresh_temp_2();
    const { workspaceId = '' } = useParams();
    const { query: { data, isPending }, } = useGetDeveloperPlatformCapabilities(workspaceId);
    if (isPending) {
        return (_jsx(Box, { align: "center", isFullHeight: true, isFullWidth: true, justify: "center", children: _jsx(LoadingBox, { alt: translate('Checking LucidLink Connect availability'), "data-testid": "checking-connect-availability", isFullHeight: true }) }));
    }
    if (data?.capabilities.nativeLayout.enabled) {
        return children;
    }
    return _jsx(Navigate, { to: `/workspaces/${workspaceId}` });
};
_react_refresh_temp_1 = WorkspaceNativeLayoutRouteGuard;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceNativeLayoutRouteGuard");
_react_refresh_temp_2(WorkspaceNativeLayoutRouteGuard, "y+wFmD1eIVn1nl91XZfFN9imtXY=", false, () => [useParams, useGetDeveloperPlatformCapabilities]);
